'use strict';

var SimpleHepToggleConfig = function SimpleHepToggleConfig(simpleHepToggleService, configurationService) {
  var hepMap = configurationService.getHepMap();
  simpleHepToggleService.initialize(hepMap);
};
SimpleHepToggleConfig.$inject = ['SimpleHepToggleService', 'ConfigurationService'];
module.exports = SimpleHepToggleConfig;